<template>
<div>
      <v-container  style="padding: 0px">
        <v-layout  class="text-xs-center">
          <v-flex xs2>
            Alpha<br/>
            <h6>{{alpha}}</h6>
          </v-flex>
          <v-flex xs2>Bravo<br/>
            <h6>{{bravo}}</h6>
          </v-flex>
          <v-flex xs2>
              Charlie<br/>
               <h6>{{charlie}}</h6>
            </v-flex>
          <v-flex xs2>Delta<br/>
            <h6>{{delta}}</h6></v-flex>
          <v-flex xs2>Echo<br/>
            <h6>{{echo}}</h6></v-flex>
          <v-flex xs2>Foxtrot<br/>
            <h6>{{foxtrot}}</h6></v-flex>
        </v-layout>
        
      </v-container>
    </div>
</template>

<script>

export default {
  name: 'countdown-bar',
  data() {
      return {
          now: Math.trunc((new Date()).getTime() / 1000)
      }
  },
  mounted() {
      window.setInterval(() => {
          this.now = Math.trunc((new Date()).getTime() / 1000);
      }, 10000);
  },
  computed: {
      alpha() {
        var fox = this.$store.getters.hunt_alpha;
        if(fox == null)
            return 0;
        var date = ((fox.time / 1000) + 3600);
        var timer = Math.trunc((date - this.now) / 60) % 60;
        return (timer < 0) ? 0 : timer;
      },
      bravo() {
        var fox = this.$store.getters.hunt_bravo;
        if(fox == null)
            return 0;
        var date = ((fox.time / 1000) + 3600);
        var timer = Math.trunc((date - this.now) / 60) % 60;
        return (timer < 0) ? 0 : timer;
      },
      charlie() {
        var fox = this.$store.getters.hunt_charlie;
        if(fox == null)
            return 0;
        var date = ((fox.time / 1000) + 3600);
        var timer = Math.trunc((date - this.now) / 60) % 60;
        return (timer < 0) ? 0 : timer;
      },
      delta() {
        var fox = this.$store.getters.hunt_delta;
        if(fox == null)
            return 0;
        var date = ((fox.time / 1000) + 3600);
        var timer = Math.trunc((date - this.now) / 60) % 60;
        return (timer < 0) ? 0 : timer;
      },
      echo() {
        var fox = this.$store.getters.hunt_echo;
        if(fox == null)
            return 0;
        var date = ((fox.time / 1000) + 3600);
        var timer = Math.trunc((date - this.now) / 60) % 60;
        return (timer < 0) ? 0 : timer;
      },
      foxtrot() {
        var fox = this.$store.getters.hunt_foxtrot;
        if(fox == null)
            return 0;
        var date = ((fox.time / 1000) + 3600);
        var timer = Math.trunc((date - this.now) / 60) % 60;
        return (timer < 0) ? 0 : timer;
      }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/maps/CountdownBar.vue